import React, { useEffect, useState } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Divider,

  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Alert,
} from "@mui/material";

import { StatusBar } from "./Index";
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import PublicOffOutlinedIcon from '@mui/icons-material/PublicOffOutlined';
import "./OKRs.css";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";
import { axiosFetch } from "../../../utils/AxiosFetch";
import moment from "moment";
import { Link } from 'react-router-dom';
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { CustomizedSnackbar } from "../../../shared/index";
import { loadStatus } from "../../../redux/actions/lookups.action";
import { useDispatch } from "react-redux";
import { SnackbarActions } from '../../../redux/actions/snackbar.actions';
import IconButton from "@mui/material/IconButton";
import { update } from "../../../redux/actions/updateData.action";
import { Close, TrafficOutlined } from "@mui/icons-material";
import LockIcon from '@mui/icons-material/Lock';



let orderByTitle = false,
  orderByDueDate = true,
  orderById = true,
  orderByStatus = false;

let isRestricted = true;

const ListOkrs = (props) => {



  var userDetails =
    localStorage.getItem("argus_user") !== null
      ? localStorage.getItem("argus_user")
      : null;
  var userid =
    userDetails !== null && JSON.parse(userDetails).userid !== null
      ? JSON.parse(userDetails).userid
      : "";

  var userType =
    userDetails !== null && JSON.parse(userDetails).usertype !== null
      ? JSON.parse(userDetails).usertype
      : "";

  const navigate = useNavigate();
  const dispatch = useDispatch();



  const [selectedOkr, setSelectedOkr] = useState("");


  const [isArchived, setIsArchived] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);


  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [isRestricted, setIsRestricted] = React.useState(true);
  const [isRestrictDraft, setIsRestrictDraft] = useState(true);
  const [isRestrictArchive, setIsRestrictArchive] = useState(true);
  const [isRestrictAddKR, setIsRestrictAddKR] = useState(true);





  const handleClick = (event, okr) => {

    setIsPublished(okr.isPublished);
    setIsPrivate(okr.isPrivate);
    setIsArchived(okr.isArchived);
    setSelectedOkr(okr);
    if (userType === 'Admin') {
      setIsRestricted(false);
      setIsRestrictDraft(false);
      setIsRestrictArchive(false);
      setIsRestrictAddKR(false);
    } else if (okr.assignedUserId.split(',').filter(id => parseInt(id) === userid).length !== 0 || (okr.createdBy.toString().split(",").filter(id => parseInt(id) === userid).length !== 0)) {
      if (okr.status === 'Opened' || okr.status === 'UnAssigned') {
        setIsRestricted(false);
        setIsRestrictDraft(false);
        setIsRestrictArchive(false);
        setIsRestrictAddKR(false);
      }
    }
    else {
      setIsRestricted(true);
      setIsRestrictDraft(true);
      setIsRestrictArchive(true);
      setIsRestrictAddKR(true);
    }
    setAnchorEl(event.currentTarget);

  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const addNewKR = () => {

    setAnchorEl(null);

    props.toggleOkrPopup("1", selectedOkr);
  }

  const closeConfirmPopup = () => {
    setOpenDialog(false);
  };

  const archiveTheOKR = () => {

    setOpenDialog(false);
    axiosFetch({
      method: "post",
      url: "/OKRs/okr/archive",
      requestConfig: {
        "objectId": selectedOkr.okrId,
        "assignmentTypeId": 1,
        "isArchived": !isArchived
      }
    })
      .then((res) => {
        if (res.status === 200) {

          isArchived ? dispatch(SnackbarActions(true, "success", "OKR UnArchived!")) : dispatch(SnackbarActions(true, "success", "OKR Archived!"));
          props.handlePageChange(1);
          setTimeout(() => {
            if (props.pageNo === 1) {
              props.loadAll_OKRs();
            }
          }, 3000)
        }
        if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        }
        else if (res.status === 401) {
          navigate("/");
        }
      })

      .catch(err => console.error(err));

  }



  const displayOKR = () => {
    setAnchorEl(null);
    navigate(`/viewokr/${selectedOkr.okrId}`, {
      state: {
        isArchived: isArchived, noOfKrs: selectedOkr.noOfKrs
      }
    });
  }

  const moveToDraft = () => {

    //close the menu
    setAnchorEl(null);
    var req = {
      "itemId": selectedOkr.okrId,
      "fieldName": "isPublished",
      "tableName": "OkrObjects",
      "value": (!selectedOkr.isPublished).toString(),
      "typeId": 2
    }

    dispatch(update(req));
    selectedOkr.isPublished ? dispatch(SnackbarActions(true, "success", "Moved to Draft!")) : dispatch(SnackbarActions(true, "success", "Removed from Draft!"));


    if (props.pageNo === 1) {
      props.loadAll_OKRs();
    }
    else {
      props.handlePageChange(1);
    }
    // setTimeout(() => {

    //   props.loadAll_OKRs();
    // }, 3000);


  };

  const openConfirmPopup = () => {

    setOpenDialog(true);
    setAnchorEl(null);
  };


  const handleSortingByDueDate = (orderby, orderdirection) => {

    var req = {
      "orderBy": orderby,
      "orderByDirection": orderdirection,
    }

    orderByDueDate = !orderByDueDate;
    // setSortByDueDate(!sortByDueDate);
    // setOrderBy(orderby);
    // setOrderByDirection(orderdirection);
    props.handleChangeSortBy(orderby, req);
    props.handlePageChange(1);
    props.handleChangeSortDirection(orderdirection);
  };

  const handleSortingByTitle = (orderby, orderdirection) => {

    var req = {
      "orderBy": orderby,
      "orderByDirection": orderdirection,
    }

    orderByTitle = !orderByTitle;
    // setSortByTitle(!sortByTitle);
    // setOrderBy(orderby);
    // setOrderByDirection(orderdirection);
    props.handleChangeSortBy(orderby, req);
    props.handlePageChange(1);
    props.handleChangeSortDirection(orderdirection);
  };

  const handleSortingById = (orderby, orderdirection) => {
    var req = {
      "orderBy": orderby,
      "orderByDirection": orderdirection,
    }

    orderById = !orderById;
    // setSortByTitle(!sortByTitle);
    // setOrderBy(orderby);
    // setOrderByDirection(orderdirection);
    props.handleChangeSortBy(orderby, req);
    props.handlePageChange(1);
    props.handleChangeSortDirection(orderdirection);
  };

  const togglePrivate = () => {
    //close the menu
    setAnchorEl(null);
    var req = {
      "itemId": selectedOkr.okrId,
      "fieldName": "isPrivate",
      "tableName": "OkrObjects",
      "value": (!selectedOkr.isPrivate).toString(),
      "typeId": 2
    }

    dispatch(update(req));
    dispatch(SnackbarActions(true, "success", "Now, Everyone can view this OKR"));


    if (props.pageNo === 1) {
      props.loadAll_OKRs();
    }
    else {
      props.handlePageChange(1);
    }

  }


  const handleSortingByStatus = (orderby, orderdirection) => {

    var req = {
      "orderBy": orderby,
      "orderByDirection": orderdirection,
    }

    orderByStatus = !orderByStatus;

    // setSortByStatus(!sortByStatus);
    // setOrderBy(orderby);
    // setOrderByDirection(orderdirection);
    props.handleChangeSortBy(orderby, req);
    props.handlePageChange(1);
    props.handleChangeSortDirection(orderdirection);
  };




  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {closeConfirmPopup ? (
          <IconButton
            aria-label="close"
            onClick={closeConfirmPopup}
            sx={{
              position: "absolute",
              right: 0,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  useEffect(() => {

    if (props.pageNo === 1) {
      dispatch(loadStatus);
    }
    else {
      dispatch(loadStatus);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <React.Fragment>
      <StatusBar statusSummary={props.summary} />
      {/* <Grid container spcaing={2} justifyContent="flex-end">
        <div className="main-legend">
          <div className="argus-legend-box">
            <div className="blue legend-box"></div>
            <h3 className="legend-list">Pass Due Date</h3>
          </div>
          <div className="argus-legend-box">
            <div className="grey legend-box"></div>
            <h3 className="legend-list">Archived</h3>
          </div>
          {window.location.pathname.includes("/myokr") ?  (
            (<div className="argus-legend-box">
              <div className="black legend-box"></div>
              <h3 className="legend-list">Private</h3>
            </div>) ) : null} 
          <div className="argus-legend-box">
            <div className="green legend-box"></div>
            <h3 className="legend-list">Completed</h3>
          </div>
        </div>
      </Grid> */}
      {/* <div className="argus-legend-chart">
        
      </div> */}
      <Paper>
        <Table className="argus-table">
          <TableHead className="tablehead">
            <TableRow sx={{ color: "#fff !important" }} >
              <TableCell align="left"> {orderById ? (
                <span
                  onClick={() => handleSortingById("Id", "DESC")}
                  style={{ cursor: "pointer" }}
                >
                  Objective Id <ArrowDownwardOutlinedIcon fontSize="13px" />{" "}
                </span>
              ) : (
                <span
                  onClick={() => handleSortingById("Id", "ASC")}
                  style={{ cursor: "pointer" }}
                >
                  Objective Id <ArrowUpwardOutlinedIcon fontSize="13px" />
                </span>
              )}</TableCell>
              <TableCell align="left">
                {orderByTitle ? (
                  <span
                    onClick={() => handleSortingByTitle("Title", "DESC")}
                    style={{ cursor: "pointer" }}
                  >
                    Objective Title <ArrowDownwardOutlinedIcon fontSize="13px" />{" "}
                  </span>
                ) : (
                  <span
                    onClick={() => handleSortingByTitle("Title", "ASC")}
                    style={{ cursor: "pointer" }}
                  >
                    Objective Title <ArrowUpwardOutlinedIcon fontSize="13px" />
                  </span>
                )}
              </TableCell>
              <TableCell align="left">Key Results</TableCell>
              <TableCell align="left">Participants</TableCell>
              <TableCell align="left">Completion %</TableCell>
              <TableCell>Created Date</TableCell>
              <TableCell align="left">
                {orderByDueDate ? (
                  <span
                    onClick={() => handleSortingByDueDate("DueDate", "DESC")}
                    style={{ cursor: "pointer" }}
                  >
                    Due Date <ArrowDownwardOutlinedIcon fontSize="13px" />
                  </span>
                ) : (
                  <span
                    onClick={() => handleSortingByDueDate("DueDate", "ASC")}
                    style={{ cursor: "pointer" }}
                  >
                    Due Date <ArrowUpwardOutlinedIcon fontSize="13px" />
                  </span>
                )}
              </TableCell>

              <TableCell align="left">
                {orderByStatus ? (
                  <span
                    onClick={() => handleSortingByStatus("Status", "DESC")}
                    style={{ cursor: "pointer" }}
                  >
                    Status <ArrowDownwardOutlinedIcon fontSize="13px" />{" "}
                  </span>
                ) : (
                  <span
                    onClick={() => handleSortingByStatus("Status", "ASC")}
                    style={{ cursor: "pointer" }}
                  >
                    Status <ArrowUpwardOutlinedIcon fontSize="13px" />
                  </span>
                )}
              </TableCell>
              <TableCell align="left">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody stripedRows>
            {props && props.okrs.length !== 0 ? props.okrs.map((okr) => (
              // <TableRow key={okr.okrId} style={{ background: okr.isArchived ? "#d9d9d9" : "" }}>
              // <TableRow key={okr.okrId} style={{ background: okr.isArchived ? "#d9d9d9" : okr.isPublished ? okr.isPrivate ? "#CDF5F6" : "" : "#CBE4F9" }}> 
              <TableRow key={okr.okrId}>
                <TableCell align="left" className="stensil-para">
                  {okr.okrId !== null ? (<Link className="kr-head" to={`/viewokr/${okr.okrId}`} state={{ isArchived: isArchived, noOfKrs: okr.noOfKrs }}>{okr.isPrivate ? (<LockIcon className="p-okr" />) : ""} {okr.okrId}</Link>) : "-"}
                </TableCell>
                {/* <TableCell>{index + 1}</TableCell> */}
                <TableCell align="left" className="stensil-para okr-t-title">
                  {okr.okrTitle !== null ? (<Link className="kr-head" to={`/viewokr/${okr.okrId}`} state={{ isArchived: isArchived, noOfKrs: okr.noOfKrs }}>{okr.okrTitle}</Link>) : "-"}
                </TableCell>
                <TableCell align="left" className="stensil-para">
                  {okr.noOfKrs !== null ? okr.noOfKrs : "-"}
                </TableCell>
                <TableCell align="left" className="stensil-para">
                  {okr.noOfParticipants !== null
                    ? okr.noOfParticipants
                    : "-"}
                </TableCell>
                <TableCell align="left" className="stensil-para">
                  {okr.completionPercentage !== null
                    ? okr.completionPercentage + "%"
                    : "-"}
                </TableCell>
                <TableCell align="left" className="stensil-para">
                  {okr.createdDate !== null
                    ? moment(okr.createdDate).format("MMM-DD-YYYY")
                    : "-"}
                </TableCell>
                <TableCell align="left" className="stensil-para">
                  {okr.dueDate !== null
                    ? moment(okr.dueDate).format("MMM-DD-YYYY")
                    : "-"}
                </TableCell>

                <TableCell align="left" className="stensil-para">
                  <span className="okr-status"
                    style={{
                      backgroundColor:okr.isArchived ? '#ff0c00' : okr.status === 'Completed' ? '#238636' : okr.status === 'In Progress' ? '#ffc107' : okr.status === 'To-Do' ? 'red' : okr.status === 'UnAssigned' ? '#6c757d' : 
                      okr.status === 'Review' ? '#000' : "#113776" 
                    }}>{okr.isArchived?"Archived":okr.status !== undefined ? okr.status : "-"}</span>
                </TableCell>

                <TableCell align="left" className="stensil-ignore hover-hand">
                  <IconButton onClick={(e) => handleClick(e, okr)}>
                    <MoreHorizIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            )) : (
              <TableRow>
                <TableCell><Stack sx={{ width: '100%', margin: "10px 0" }} spacing={2}><Alert severity="error" sx={{ width: "413%" }}>No Records Found</Alert></Stack></TableCell>
              </TableRow>
            )}

            {/* {okrlist &&
                okrlist.length !== 0 &&
                okrlist?.map((okr,index) => )} */}
          </TableBody>
        </Table>
      </Paper>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={displayOKR}><VisibilityIcon /> &nbsp; View this OKR</MenuItem>
        <Divider />
        <MenuItem onClick={addNewKR} disabled={isRestricted} > <AddIcon />  &nbsp;Add KR</MenuItem>
        <Divider />
        <MenuItem onClick={moveToDraft} disabled={isRestrictDraft} > <EditIcon /> &nbsp;{selectedOkr.isPublished ? " Move to Draft" : "Remove from Draft"}</MenuItem>
        <Divider />
        <MenuItem onClick={openConfirmPopup} disabled={isRestrictArchive}> <DeleteIcon /> &nbsp;{selectedOkr.isArchived ? "UnArchive" : "Archive"}</MenuItem>
        {isPrivate ? <Divider /> : ""}
        {isPrivate ? <MenuItem disabled={isRestricted} onClick={togglePrivate}><PublicOutlinedIcon />Make it Public</MenuItem> : ""}
      </Menu>

      <Dialog
        open={openDialog}
        onClose={closeConfirmPopup}
        aria-describedby="alert-dialog-slide-description"
        className="small-info-popup"
        fullWidth="sm"
        maxWidth="sm"
      >
        <BootstrapDialogTitle className="modal-heading">
          Archiving OKR
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Stack sx={{ width: '100%' }} spacing={2}>
            <Alert severity="error">{!isPublished ? "Archiving the draft item will be deleted permanently.  Are you sure want to continue?" : isArchived ? "Are you sure you want to UnArchive?" : "Are you sure you want to Archive?"}</Alert></Stack>
          {/* <DialogContentText id="alert-dialog-slide-description">
            {isArchived ? "Are you sure you want to UnArchive?" : "Are you sure you want to Archive?"}
          </DialogContentText> */}
        </DialogContent>
        <DialogActions dividers>
          <Button onClick={closeConfirmPopup} className="no-btn theme-btn cancel-btn">No</Button>
          <Button onClick={archiveTheOKR} className="yes-btn theme-btn">Yes</Button>

        </DialogActions>
      </Dialog>

      <CustomizedSnackbar />
    </React.Fragment >
  );
};

export default ListOkrs;
